import * as yup from 'yup';
const alphabetOnly = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/;
const alphanumericOnly = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;
const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
//  const phoneRegex = /^\+\d{1,4}([-\s.]?\(?\d+\)?)+$/; // allows for alphanumeric and basic symbols, adjust as needed
const phoneRegex = /^\+(\d{1,3})\s\d{10}$/;
 export const contactInfoFormValidations = yup.object().shape({
  // 1. Primary Business Contact
  primary_contact: yup.object().shape({
    full_name: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(50, "Maximum 50 characters allowed for Full Name")
      .required("Full Name is required"),
    job_title: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(30, "Maximum 30 characters allowed for Job Title/Role")
      .required("Job Title/Role is required"),
    email_address: yup
      .string()
      .trim()
      .matches(emailRegex, "Invalid email address")
      .max(30, "Maximum 30 characters allowed for Email Address")
      .required("Email Address is required"),
    phone_number: yup
      .string()
      .trim()
      .matches(phoneRegex, "Enter your phone number in the format: +<country code> <space> <10-digit number> (e.g., +1 1234567890).")
      .max(20, "Maximum 20 characters allowed for Phone Number")
      .required("Phone Number is required"),
    department: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(50, "Maximum 50 characters allowed for Department")
  }),

  // 2. Technical Contact
  technical_contact: yup.object().shape({
    full_name: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(50, "Maximum 50 characters allowed for Full Name")
      .required("Full Name is required"),
    job_title: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(30, "Maximum 30 characters allowed for Job Title/Role")
      .required("Job Title/Role is required"),
    email_address: yup
      .string()
      .matches(emailRegex, "Invalid email address")
      .max(30, "Maximum 30 characters allowed for Email Address")
      .required("Email Address is required"),
    phone_number: yup
      .string()
      .matches(phoneRegex, "Enter your phone number in the format: +<country code> <space> <10-digit number> (e.g., +1 1234567890).")
      .max(20, "Maximum 20 characters allowed for Phone Number")
      .required("Phone Number is required"),
  }),

  // 3. Billing/Finance Contact
  billing_contact: yup.object().shape({
    legal_entity: yup
      .string()
      .trim()
      .matches(alphanumericOnly, "Only alphanumeric characters allowed")
      .max(30, "Maximum 30 characters allowed for Legal Entity Name")
      .required("Legal Entity Name is required"),
    full_name: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(50, "Maximum 50 characters allowed for Full Name")
      .required("Full Name is required"),
    job_title: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(30, "Maximum 30 characters allowed for Job Title/Role")
      .required("Job Title/Role is required"),
    email_address: yup
      .string()
      .trim()
      .matches(emailRegex, "Invalid email address")
      .max(30, "Maximum 30 characters allowed for Email Address")
      .required("Email Address is required"),
    phone_number: yup
      .string()
      .matches(phoneRegex, "Enter your phone number in the format: +<country code> <space> <10-digit number> (e.g., +1 1234567890).")
      .max(20, "Maximum 20 characters allowed for Phone Number")
      .required("Phone Number is required"),
    street: yup
      .string()
      .trim()
      .matches(alphanumericOnly, "Only alphanumeric characters allowed")
      .max(50, "Maximum 50 characters allowed for Street")
      .required("Street is required"),
    city: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(30, "Maximum 30 characters allowed for City")
      .required("City is required"),
    state: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(20, "Maximum 20 characters allowed for State/County")
      .required("State/County is required"),
    zip: yup
      .string()
      .trim()
      .matches(alphanumericOnly, "Only alphanumeric characters allowed")
      .max(10, "Maximum 10 characters allowed for Zip/Post Code")
      .required("Zip/Post Code is required"),
    country: yup
      .string()
      .trim()
      .matches(alphanumericOnly, "Only alphanumeric characters allowed")
      .max(20, "Maximum 20 characters allowed for Country")
      .required("Country is required"),
  }),

  // 4. Support/Emergency Contact
  support_contact: yup.object().shape({
    full_name: yup
      .string()
      .trim()
      .matches(alphabetOnly, "Only alphabets allowed")
      .max(50, "Maximum 50 characters allowed for Full Name")
      .required("Full Name is required"),
    email_address: yup
      .string()
      .matches(emailRegex, "Invalid email address")
      .max(30, "Maximum 30 characters allowed for Email Address")
      .required("Email Address is required"),
    phone_number: yup
      .string()
      .matches(phoneRegex, "Enter your phone number in the format: +<country code> <space> <10-digit number> (e.g., +1 1234567890).")
      .max(20, "Maximum 20 characters allowed for Phone Number")
      .required("Phone Number is required"),
  }),
});
